<button
    type="button"
    role="combobox"
    aria-haspopup="listbox"
    [id]="id + '-combobox'"
    [value]="currentProduct().title"
    [attr.aria-controls]="id + '-listbox'"
    [attr.aria-labelledby]="labeledBy()"
    [attr.aria-expanded]="expanded()"
    [attr.aria-activedescendant]="id + '-option-' + focusedOption()"
    (click)="toggle()"
    (keydown)="handleButtonKeydown($event)"
    (blur)="collapse()"
>
    <div class="contract-icon">
        <i
            [ctrlIcon]="currentProduct().portalConfig.icon ?? 'insurance_fallback'"
            [size]="currentProduct().portalConfig.iconSize ?? '52px'"
        ></i>
    </div>
    <span [innerHTML]="currentProduct().collapsableTitle"></span>
    <i
        ctrlIcon="chevron_right"
        class="c:blue-1"
    ></i>
</button>
@if (expanded()) {
    <ul
        role="listbox"
        [id]="id + '-listbox'"
    >
        @for (contractWithProduct of contractsWithProducts(); track contractWithProduct.contract.id; let $i = $index) {
            <li
                role="option"
                [id]="id + '-option-' + $i"
                [attr.aria-selected]="$i === focusedOption()"
                [ngClass]="{ '-selected': $i === focusedOption() }"
                (mousedown)="handleOptionMouseDown($event, $i)"
            >
                <div class="contract-icon">
                    <i
                        [ctrlIcon]="contractWithProduct.product.portalConfig.icon ?? 'insurance_fallback'"
                        [size]="contractWithProduct.product.portalConfig.iconSize ?? '52px'"
                        class="c:blue-700"
                    ></i>
                </div>
                <span [innerHTML]="contractWithProduct.product.collapsableTitle"></span>
            </li>
        }
    </ul>
}
